import { Component } from "react";
import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { autenticar } from "./../actions/AutenticacaoActions";

import { ApresentacaoPdf } from "../paginas/externas/ApresentacaoPdf";
import Home from "../paginas/externas/Home";

import Cadastro from "../paginas/externas/Cadastro";
import { Consultores } from "../paginas/externas/Consultores";
import Contato from "../paginas/externas/Contato";
import Login from "../paginas/externas/LoginCliente";
import Pagamento from "../paginas/externas/Pagamento";
import Transacao from "../paginas/externas/Transacao";
import Inicio from "../paginas/internas/Painel/Inicio";

import Forbiden from "../paginas/externas/Forbiden";
import PrivateRoute from "./PrivateRoute";

class Routes extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/para-empresas" component={ApresentacaoPdf} />
        <Route exact path="/contato" component={Contato} />
        <Route path="/cadastro" component={Cadastro} />
        <Route exact path="/login-cliente" component={Login} />
        <Route exact path="/acesso-proibido" component={Forbiden} />
        <Route exact path="/pagamento" component={Pagamento} />
        <Route exact path="/transacao" component={Transacao} />
        <Route exact path="/consultores" component={Consultores} />

        {/***teste*****
         * 
        <Route
          exact
          path="/teste/:id"
          component={(props) => {
            console.log(process.env)           

            const id = props.match.params.id;
            let url = "";
            if (id === "1") {
              url = "http://localhost/Salud_Backend/backend/api/teste-headers";
            } else {
              url = "https://secuidae.com.br/api/teste-headers";
            }
            axios.get(url).then((response) => {
              console.log(response.data);
            });
             
          }}/>          
        */}

        <PrivateRoute path="/painel/inicio" component={Inicio} />
        <PrivateRoute
          path="/painel/clientes/listar"
          component={() => <h1>Oi</h1>}
        />
      </Switch>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    autenticacao: state.autenticacao.autenticado,
  };
};

export default connect(mapStateToProps, { autenticar })(Routes);
